//#region Imports
import Agenda from './pages/Agenda';
import Assets from './pages/Assets';
import AssetsLogs from './pages/AssetsLogs';
import ClientInfo from './pages/ClientInfo';
import Clients from './pages/Clients';
import Config from './pages/Config';
import Contacts from './pages/Contacts';
import Dashboard from './pages/Dashboard';
import TechDetails from './pages/Details/TechDetails';
import VisitDetails from './pages/Details/VisitDetails';
import EquipAttr from './pages/EquipAttr';
import Equipments from './pages/Equipments';
import EquipmentsLogs from './pages/EquipmentsLogs';
import FollowVisits from './pages/FollowVisits';
import Items from './pages/Items';
import ListUser from './pages/ListUsers';
import LocHistory from './pages/LocHistory';
import SiteAssets from './pages/SiteAssets';
import Sites from './pages/Sites';
import Tecnicos from './pages/Tecnicos';
import Tutorials from './pages/TutorialsCatalog';
import Visits from './pages/Visits';
import IndicatorsPage from './pages/Indicators';
import IndicatorsPage2 from './pages/Indicators2';
import IndicatorsPage3 from './pages/Indicators3';
import ReportsBuilder from './pages/ReportsBuilder';
import MaintenanceAgenda from './pages/MaintenanceAgenda';
import Inventory from './pages/Inventory';
import InventoryEntries from './pages/InventoryEntries';
import InventoryManufacturers from './pages/InventoryManufacturers.js';
import InventoryStore from './pages/InventoryStore';
import InventoryAdmon from './pages/InventoryAdmon.js';
import InventoryLocations from './pages/InventoryLocations.js';
import Licenses from './pages/Licenses.jsx';
import RegionsPage from './pages/Sigma/RegionsPage.jsx';
import FailureTypesPage from './pages/Sigma/FailureTypesPage.jsx';
import FailuresPage from './pages/Sigma/FailuresPage.jsx';
import RolePermissions from './pages/Permissions/RolePermissions';
import UserPermissions from './pages/Permissions/UserPermissions';
import ListRoles from './pages/ListRoles';
import EquipmentsMaintenance from './pages/Sigma/EquipmentsMaintenance.jsx';
import LocationPage from './pages/LocationPage.jsx';
import BrandPage from './pages/BrandPage.jsx';
import ModelPage from './pages/ModelPage.jsx';
// import ScheduleLog from './pages/Sigma/ScheduleLog.jsx';
import Surveys from './pages/Sigma/Surveys.jsx';
//#endregion

// Routes and perms
export const routes = [
  {
    path: '/dashboard',
    element: <Dashboard />,
    requiredPermissions: ['Read Dashboard'],
    breadcrumb: 'Inicio',
  },
  {
    path: '/agenda',
    element: <Agenda />,
    requiredPermissions: ['Read Dashboard'],
    breadcrumb: 'Agenda',
  },
  {
    path: '/agenda/week',
    element: <Agenda />,
    requiredPermissions: ['Read Dashboard'],
    breadcrumb: 'Semana',
  },
  {
    path: '/agenda/year',
    element: <MaintenanceAgenda />,
    requiredPermissions: ['Read Dashboard'],
    breadcrumb: 'Año',
  },
  {
    path: '/indicators-2',
    element: <IndicatorsPage2 />,
    requiredPermissions: ['List Indicators'],
    breadcrumb: 'Indicadores',
  },
  {
    path: '/indicators',
    element: <IndicatorsPage />,
    requiredPermissions: ['List Indicators'],
    breadcrumb: 'Indicadores',
  },
  {
    path: '/indicators-3',
    element: <IndicatorsPage3 />,
    requiredPermissions: ['List Indicators Surveys'],
    breadcrumb: 'Indicadores',
  },
  {
    path: '/config',
    element: <Config />,
    requiredPermissions: ['Read Dashboard'],
    breadcrumb: 'Configuración',
  },
  {
    path: '/reportsBuilder',
    element: <ReportsBuilder />,
    requiredPermissions: ['Read Dashboard'],
    breadcrumb: 'Constructor de reportes',
  },
  {
    path: '/users/permissions/:userId',
    element: <UserPermissions />,
    requiredPermissions: ['List Users'],
    breadcrumb: 'Usuarios',
  },
  {
    path: '/roles/permissions/:roleId',
    element: <RolePermissions />,
    // requiredPermissions: ['List Roles']
  },
  {
    path: '/clients',
    element: <Clients />,
    requiredPermissions: ['List Clients'],
    breadcrumb: 'Clientes',
  },
  {
    path: '/sites',
    element: <Sites />,
    requiredPermissions: ['List Sites'],
    breadcrumb: 'Sitios',
  },
  {
    path: '/contacts',
    element: <Contacts />,
    requiredPermissions: ['List Contacts'],
    breadcrumb: 'Contactos',
  },
  {
    path: '/tecnicos',
    element: <Tecnicos />,
    requiredPermissions: ['List Technicals'],
    breadcrumb: 'Técnicos',
  },
  {
    path: '/tech/details/:id',
    element: <TechDetails />,
    requiredPermissions: ['List Technicals'],
    breadcrumb: 'Detalles del técnico',
  },
  {
    path: '/historyTechs',
    element: <LocHistory />,
    requiredPermissions: ['View technical history'],
    breadcrumb: 'Historial de geolocalización',
  },
  {
    path: '/visits',
    element: <Visits />,
    requiredPermissions: ['List Visits'],
    breadcrumb: 'Visitas',
  },
  // {
  //   path: '/visits/incomplete',
  //   element: <Visits incomplete={1} />,
  //   requiredPermissions: ['List Visits'],
  //   breadcrumb: 'Visitas',
  // },
  {
    path: '/visits/details/:id',
    element: <VisitDetails />,
    requiredPermissions: ['List Visits'],
    breadcrumb: 'Detalles de la visita',
  },
  {
    path: '/followVisits',
    element: <FollowVisits />,
    requiredPermissions: ['List Visits'],
    breadcrumb: 'Control de visitas',
  },
  {
    path: '/serviceTypes',
    element: <FailureTypesPage />,
    requiredPermissions: ['View Failure Types'],
    breadcrumb: 'Tipos de servicio',
  },
  {
    path: '/serviceTypes/failures/:id',
    element: <FailuresPage />,
    requiredPermissions: ['View Failures'],
    breadcrumb: 'Fallas ID: :id',
  },
  // {
  //   path: '/schedule-log',
  //   element: <ScheduleLog />,
  //   // requiredPermissions: ['List Schedule Log'],
  //   breadcrumb: 'Bitacora de horarios',
  // },
  {
    path: '/equipments',
    element: <Equipments />,
    requiredPermissions: ['List Equipments'],
    // requiredPermissions: ['Coming Soon'],
    breadcrumb: 'Tipos de equipos',
  },
  {
    path: '/equipLogs',
    element: <EquipmentsLogs />,
    requiredPermissions: ['List Equipments'],
    breadcrumb: 'Logs de tipos de equipos',
  },
  {
    path: '/equipmentAttr',
    element: <EquipAttr />,
    // requiredPermissions: ['List Equipments']
    requiredPermissions: ['Coming Soon'],
    breadcrumb: 'Atributos de tipos de equipos',
  },
  {
    path: '/items',
    element: <Items />,
    // requiredPermissions: ['List Items']
    requiredPermissions: ['Coming Soon'],
    breadcrumb: 'Items',
  },
  {
    path: '/assets',
    element: <Assets />,
    requiredPermissions: ['List Assets'],
    // requiredPermissions: ['Coming Soon'],
    breadcrumb: 'Equipos',
  },
  {
    path: '/assetLogs',
    element: <AssetsLogs />,
    requiredPermissions: ['List Assets'],
    breadcrumb: 'Logs de equipos',
  },
  {
    path: '/inventory',
    element: <Inventory />,
    // requiredPermissions: ['List Inventory']
    breadcrumb: 'Inventario',
  },
  {
    path: '/inventory/admon',
    element: <InventoryAdmon />,
    // requiredPermissions: ['List Inventory']
    breadcrumb: 'Administración de inventario',
  },
  {
    path: '/inventory/locations',
    element: <InventoryLocations />,
    // requiredPermissions: ['List Inventory']
    breadcrumb: 'Localizaciones de almacén',
  },
  {
    path: '/inventory/entries',
    element: <InventoryEntries />,
    // requiredPermissions: ['List Inventory']
    breadcrumb: 'Entradas y salidas',
  },
  {
    path: '/inventory/manufacturers',
    element: <InventoryManufacturers />,
    // requiredPermissions: ['List Inventory']
    breadcrumb: 'Fabricantes',
  },
  {
    path: '/inventory/store',
    element: <InventoryStore />,
    // requiredPermissions: ['List Inventory']
  },
  {
    path: '/tutorials',
    element: <Tutorials />,
    requiredPermissions: ['Coming Soon'],
  },
  {
    path: '/licenses',
    element: <Licenses />,
    breadcrumb: 'Licensias',
  },
  {
    path: '/regions',
    element: <RegionsPage />,
    requiredPermissions: ['View Regions'],
    breadcrumb: 'Regiones',
  },
  {
    path: '/locations-assets',
    element: <LocationPage />,
    requiredPermissions: ['List Assets'],
    breadcrumb: 'Ubicaciones',
  },
  {
    path: '/brands',
    element: <BrandPage />,
    requiredPermissions: ['List Assets'],
    breadcrumb: 'Marca',
  },
  {
    path: '/models',
    element: <ModelPage />,
    requiredPermissions: ['List Assets'],
    breadcrumb: 'Modelos',
  },
  {
    path: '/equipments-maintenance',
    element: <EquipmentsMaintenance />,
    breadcrumb: 'Mantenimientos a tipos de equipos',
    requiredPermissions: ['List Maintenance Equipments'],
  },
  // {
  //   path: '/surveys',
  //   element: <Surveys />,
  //   breadcrumb: 'Encuestas',
  //   requiredPermissions: ['Beta Visit Type'],
  // },
];
